/**
 * Multisite agreement copy — LOC-1740
 *
 * DO NOT EDIT THE STRINGS BELOW WITHOUT LEGAL/COMPLIANCE SIGN-OFF.
 * Wording is locked per ticket AC. Any change requires a new sign-off
 * recorded against this file in source control.
 *
 * The paragraph is an ordered list of segments, each a run of text followed by
 * an optional link. Rendering them in order reproduces the locked wording, and
 * punctuation stays in the text so it never lands inside the anchor.
 */

export interface AgreementLink {
  label: string;
  url: string;
  /* Both links read "here", so screen readers need a descriptive label. */
  ariaLabel: string;
}

export interface MultisiteAgreementCopy {
  content: string;
  link?: AgreementLink;
}

const tariffLink: AgreementLink = {
  label: "here",
  url: "https://www.originenergy.com.au/wp-content/uploads/131/6785-Current-residential-electricity-and-gas-tariffs.pdf",
  ariaLabel: "Current residential electricity and gas tariffs (PDF)",
};

const feesLink: AgreementLink = {
  label: "here",
  url: "https://www.originenergy.com.au/wp-content/uploads/287/12201-Meter-installation-alteration-and-abolishment-fees.pdf",
  ariaLabel: "Meter installation, alteration and abolishment fees (PDF)",
};

export const getMultisiteAgreementCopy = (
  fuel: string
): MultisiteAgreementCopy[] => [
  {
    content: `I understand and agree that upon installation of ${fuel} for the supply address requested, the terms and conditions of the multisite agreement will apply to this supply address. The charges applicable to the supply address will depend on the meter type and distribution zone of the supply address and will be the applicable Origin Basic charges – current charges can be found `,
    link: tariffLink,
  },
  {
    content: `. With Origin Basic, the charges are variable – we’ll always let you know if they change. Fees for meter installation can be found `,
    link: feesLink,
  },
  { content: "." },
];
